import { ChatPermissionMode } from '@/modules/common/types';

export const CHAT_PERMISSION_MODE_STORAGE_KEY = 'mavue.chat.permissionMode';

export const CHAT_PERMISSION_MODE_DISPLAY_ORDER = [
  ChatPermissionMode.DEFAULT_PERMISSIONS,
  ChatPermissionMode.AUTO_REVIEW,
  ChatPermissionMode.FULL_ACCESS,
] as const satisfies readonly ChatPermissionMode[];

export function isChatPermissionMode(value: unknown): value is ChatPermissionMode {
  return CHAT_PERMISSION_MODE_DISPLAY_ORDER.some((option) => option === value);
}

export function readStoredChatPermissionMode() {
  if (typeof window === 'undefined') {
    return ChatPermissionMode.DEFAULT_PERMISSIONS;
  }

  const storedValue = window.localStorage.getItem(CHAT_PERMISSION_MODE_STORAGE_KEY);

  if (isChatPermissionMode(storedValue)) {
    return storedValue;
  }

  if (storedValue) {
    window.localStorage.removeItem(CHAT_PERMISSION_MODE_STORAGE_KEY);
  }

  return ChatPermissionMode.DEFAULT_PERMISSIONS;
}
